const ok = (data) => ({ ok: true, data });
const err = (error) => ({
  ok: false,
  error
});
const wrapThrows = (fn) => (...args) => {
  try {
    return {
      ok: true,
      data: fn(...args)
    };
  } catch (error) {
    return {
      ok: false,
      error
    };
  }
};
async function makeRequest(apiHost, endpoint, method, data) {
  const url = new URL(endpoint, apiHost);
  const body = JSON.stringify(data);
  const res = wrapThrows(fetch)(url.toString(), {
    method,
    headers: {
      "Content-Type": "application/json"
    },
    body
  });
  if (res.ok === false)
    return err(res.error);
  const response = await res.data;
  const { data: innerData } = await response.json();
  if (!response.ok) {
    return err({
      code: "network_error",
      message: response.statusText,
      status: response.status,
      url
    });
  }
  return ok(innerData);
}
class ResponseAPI {
  constructor(apiHost, environmentId) {
    this.apiHost = apiHost;
    this.environmentId = environmentId;
  }
  async create(responseInput) {
    return makeRequest(this.apiHost, `/api/v1/client/${this.environmentId}/responses`, "POST", responseInput);
  }
  async update({
    responseId,
    finished,
    data
  }) {
    return makeRequest(this.apiHost, `/api/v1/client/${this.environmentId}/responses/${responseId}`, "PUT", {
      finished,
      data
    });
  }
}
class DisplayAPI {
  constructor(baseUrl, environmentId) {
    this.apiHost = baseUrl;
    this.environmentId = environmentId;
  }
  async create(displayInput) {
    return makeRequest(this.apiHost, `/api/v1/client/${this.environmentId}/displays`, "POST", displayInput);
  }
  async update(displayId, displayInput) {
    return makeRequest(
      this.apiHost,
      `/api/v1/client/${this.environmentId}/displays/${displayId}`,
      "PUT",
      displayInput
    );
  }
}
class Client {
  constructor(options) {
    const { apiHost, environmentId } = options;
    this.response = new ResponseAPI(apiHost, environmentId);
    this.display = new DisplayAPI(apiHost, environmentId);
  }
}
class SentimentAPI {
  constructor(options) {
    this.client = new Client(options);
  }
}
export {
  SentimentAPI
};
//# sourceMappingURL=index.mjs.map
